// Dashboards glyph from the design (4-tile layout). Two variants:
//   - filled:  solid tiles, used on the dark nav (renders white via currentColor)
//   - outline: stroked tiles, used on the light list-page cards (renders grey via currentColor)
// Both use currentColor so the parent's text color drives the icon color.
export const DashboardsIcon = ({
  size = 16,
  variant = 'outline',
}: {
  size?: number
  variant?: 'filled' | 'outline'
}) => {
  if (variant === 'filled') {
    return (
      <svg width={size} height={size} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="8.66142" height="6.38152" rx="1" fill="currentColor" />
        <rect x="11.3386" y="13.6953" width="8.66142" height="6.38152" rx="1" fill="currentColor" />
        <rect x="11.3386" width="8.66142" height="11.2066" rx="1" fill="currentColor" />
        <rect y="8.87109" width="8.66142" height="11.2066" rx="1" fill="currentColor" />
      </svg>
    )
  }

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V7.33333C2 7.70152 2.29848 8 2.66667 8H6C6.36819 8 6.66667 7.70152 6.66667 7.33333V2.66667C6.66667 2.29848 6.36819 2 6 2Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 2H10C9.63182 2 9.33334 2.29848 9.33334 2.66667V4.66667C9.33334 5.03486 9.63182 5.33333 10 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667V2.66667C14 2.29848 13.7015 2 13.3333 2Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 8H10C9.63182 8 9.33334 8.29848 9.33334 8.66667V13.3333C9.33334 13.7015 9.63182 14 10 14H13.3333C13.7015 14 14 13.7015 14 13.3333V8.66667C14 8.29848 13.7015 8 13.3333 8Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10.668H2.66667C2.29848 10.668 2 10.9664 2 11.3346V13.3346C2 13.7028 2.29848 14.0013 2.66667 14.0013H6C6.36819 14.0013 6.66667 13.7028 6.66667 13.3346V11.3346C6.66667 10.9664 6.36819 10.668 6 10.668Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
